module.exports = __webpack_public_path__ + "img/Entertainment-Filled.cb6164d9.svg";